import { type Pagination } from '../types/search';

const getOffset = ({ currentPage, size, offset, limit }: Pagination): number => {
    const pageOffset = currentPage && currentPage > 1 ? (currentPage - 1) * size : offset;

    return limit ? Math.min(pageOffset, limit) : pageOffset;
};

export { getOffset };
